var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grid-card cols" }, [
    _c("div", { staticClass: "row no-gutters inner-wrapper" }, [
      _c("a", { staticClass: "image-link", attrs: { href: _vm.item.link } }),
      _vm._v(" "),
      _c("div", { staticClass: "image" }, [
        _c("div", { staticClass: "image-wrapper", style: _vm.backgroundImage }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("a", { staticClass: "cta" }, [
          _c("div", { staticClass: "icon" }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.item.title.rendered))]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/EnsembleCard.vue